/**
 * Open Telegram deep links in a way that works on iOS Safari and Telegram in-app browser.
 * iOS blocks popups after async/await; navigating the current tab is the most reliable.
 *
 * Platform behavior:
 * - iOS: Uses same-tab navigation (window.location.href) to bypass popup blocking
 * - Other platforms: Opens in new tab, keeps original page unchanged
 */
export function openBotDeepLink(deepLink) {
  if (!deepLink) return;

  const ua = navigator.userAgent || '';
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    // Use same-tab navigation to avoid popup blocking and ensure universal links trigger Telegram
    window.location.href = deepLink;
    return;
  }

  // Non-iOS: open in new tab, do NOT fallback to location.href to preserve original page
  window.open(deepLink, '_blank', 'noopener,noreferrer');
}
